/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitResultBody
 */
export interface SubmitResultBody {
    /**
     * 
     * @type {number}
     * @memberof SubmitResultBody
     */
    homeScore: number;
    /**
     * 
     * @type {number}
     * @memberof SubmitResultBody
     */
    awayScore: number;
}

/**
 * Check if a given object implements the SubmitResultBody interface.
 */
export function instanceOfSubmitResultBody(value: object): value is SubmitResultBody {
    if (!('homeScore' in value) || value['homeScore'] === undefined) return false;
    if (!('awayScore' in value) || value['awayScore'] === undefined) return false;
    return true;
}

export function SubmitResultBodyFromJSON(json: any): SubmitResultBody {
    return SubmitResultBodyFromJSONTyped(json, false);
}

export function SubmitResultBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitResultBody {
    if (json == null) {
        return json;
    }
    return {
        
        'homeScore': json['homeScore'],
        'awayScore': json['awayScore'],
    };
}

export function SubmitResultBodyToJSON(json: any): SubmitResultBody {
    return SubmitResultBodyToJSONTyped(json, false);
}

export function SubmitResultBodyToJSONTyped(value?: SubmitResultBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'homeScore': value['homeScore'],
        'awayScore': value['awayScore'],
    };
}

